module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_marathi.a7c8bb12.mp3";